document.addEventListener("DOMContentLoaded", function () {

    const hero = document.querySelector(".login-hero");

    const slider = new Swiper(".login-hero-slider", {

        effect: "fade",

        fadeEffect: {
            crossFade: true
        },

        loop: true,

        speed: 1000,

        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },

        pagination: {
            el: ".login-pagination",
            clickable: true
        },

        on: {

            init: function () {

                hero.style.background =
                    this.slides[this.activeIndex].dataset.bg;

            },

            slideChangeTransitionStart: function () {

                hero.style.background =
                    this.slides[this.activeIndex].dataset.bg;

            }

        }

    });

});